<template>
  <b-modal
    id="chat-setting-model"
    cancel-variant="outline-secondary"
    :ok-title="$t('button.saveChanges')"
    :cancel-title="$t('button.close')"
    centered
    no-close-on-backdrop
    :title="$t('breadcrumb.chatSettings')"
    @ok="submit"
  >
    <validation-observer ref="chatSettingsForm" #default="{ invalid }">
      <!-- form -->
      <div class="d-flex flex-row mb-2">
        <div class="d-flex flex-row border rounded px-2 py-2 w-100">
          <b-form-checkbox
            v-model="isTranslateOn"
            @change="isTranslateOn != isTranslateOn"
          />
          <div class="d-flex flex-column">
            <h4>{{ $t("translate.translation") }}</h4>
            <span>{{ $t("translate.translate_desc") }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row">
        <div class="d-flex flex-row border rounded px-2 py-2 w-100">
          <b-form-checkbox v-model="isHideOn" @change="isHideOn != isHideOn" />
          <div class="d-flex flex-column">
            <h4>{{ $t("translate.hideSystemAutomaticMessages") }}</h4>
            <span>{{ $t("translate.hideSystemAutomaticMessages_desc") }}</span>
          </div>
        </div>
      </div>
    </validation-observer>

    <template #modal-ok>
      <b-spinner small label="Spinning" v-if="loading"></b-spinner>
      <span v-else>
        {{ $t("button.saveChanges") }}
      </span>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BSpinner,
  BFormGroup,
  BBadge,
  BFormCheckbox,
} from "bootstrap-vue";
import NInput from "@/components/NInput";
import Repository from "@/repositories/RepositoryFactory";
import NFormConfirmation from "@/components/NFormConfirmation";
import NAsyncSingleSelect from "@/components/NAsyncSingleSelect.vue";
import useJwt from "@/auth/jwt/useJwt";

const ProfileRepository = Repository.get("profile");

export default {
  components: {
    BModal,
    BSpinner,
    BFormGroup,
    BBadge,
    NFormConfirmation,
    NInput,
    NAsyncSingleSelect,
    BFormCheckbox,
  },
  computed: {
    userData: function () {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  data() {
    return {
      loading: false,
      isTranslateOn: false,
      isHideOn: false,
      user: "",
      data: {
        token: "",
        userId: "",
      },
      key: 1,
    };
  },
  created() {
    if (this.userData) {
      this.isTranslateOn = JSON.parse(
        localStorage.getItem("chatSettings")
      ).isTranslationOn;
      this.isHideOn = JSON.parse(
        localStorage.getItem("chatSettings")
      ).isHideSystemChat;
    }
  },
  methods: {
    show() {
      this.$bvModal.show("chat-setting-model");
    },
    hide() {
      this.$bvModal.hide("chat-setting-model");
    },
    submit() {
      this.loading = true;
      const payload = {
        isTranslationOn: this.isTranslateOn ? this.isTranslateOn : false,
        isHideSystemChat: this.isHideOn ? this.isHideOn : false,
      };
      ProfileRepository.updateChatSettings(payload)
        .then((response) => {
          const user = response?.data?.data;
          const settings = JSON.stringify(user.chatSettings);

          this.$store.commit("profile/UPDATE_SETTING", user.chatSettings);
          this.$emit("reloadChannel");
          localStorage.setItem("chatSettings", settings);

          window.dispatchEvent(
            new CustomEvent("chatSettings", { data: { settings } })
          );
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
